import { type FunctionComponent } from 'react';
import { useEmployee } from '../../hooks/apollo/employee/employee.hooks';
import { PageContainer } from '../common-components/page/page-container/page-container.component';
import { LayoutController, type LayoutControllerProps } from '../layouts/layout.controller';

const AccessDenied: FunctionComponent = () => {
	return (
		<LayoutController>
			<PageContainer
				canonicalURL="/login"
				pageTitle="Access Denied"
				metaDescription="Only authenticated employee can access the page.">
				<div className="center flex justify-center pv5">
					<span>You have to be authenticated employee to access this page.</span>
				</div>
			</PageContainer>
		</LayoutController>
	);
};

export type EmployeeOnlyRouteProps = LayoutControllerProps;

export const EmployeeOnlyRoute: FunctionComponent<EmployeeOnlyRouteProps> = ({ children }) => {
	const {
		employee: { isAuthenticated }
	} = useEmployee();

	return isAuthenticated ? children : <AccessDenied />;
};
